import { MetricConverter } from './helpers';

const CurrentSlewRateUnits = ['A/s', 'kA/s', 'MA/s', 'GA/s'] as const;
export type TCurrentSlewRateUnit = (typeof CurrentSlewRateUnits)[number];

class CurrentSlewRateConverter extends MetricConverter<TCurrentSlewRateUnit, 'A/s'> {
    baseUnit = 'A/s' as const;
    units = CurrentSlewRateUnits;
}

export const currentSlewRateConverter = new CurrentSlewRateConverter();
